import { render } from "./Avatar.vue?vue&type=template&id=2ababadc"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/app/header/Avatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ababadc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ababadc', __exports__)) {
    console.log('reload')
    api.reload('2ababadc', __exports__)
  }
  
  module.hot.accept("./Avatar.vue?vue&type=template&id=2ababadc", () => {
    console.log('re-render')
    api.rerender('2ababadc', render)
  })

}


export default __exports__